import { render, staticRenderFns } from "./ProductSerialNumber.vue?vue&type=template&id=76bc8f14"
import script from "./ProductSerialNumber.vue?vue&type=script&lang=js"
export * from "./ProductSerialNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports